module.exports = __webpack_public_path__ + "static/media/S15_W.662aba84.png";